import PlaySound from "./play_sound";
import { PLAYER_TYPE } from './player_type';
export default class ReadSentenceTurnPage extends PlaySound {
    constructor(el, target) {
        super(el, target);
        this.turnPageTimes = el.turnPageTimes;

        this.audio = window.soundManager.soundPlayer;
        this.playerType = PLAYER_TYPE.SIMPLE;
    }

    init() {
        //解析輸入的時間，轉換成陣列
        this.turnPageTimes = this.turnPageTimes.replace(/\[*\]*/g, '');

        let temp_turnPages = this.turnPageTimes.split(',');
        this.turnPageTimes = [];
        for (let i = 0; i < temp_turnPages.length; i++) {
            let min;
            let sec;
            let temp;
            temp = temp_turnPages[i].split(":").map(Number);
            min = temp[0];
            sec = temp[1];
            this.turnPageTimes.push(min * 60 + sec);
        }

        this.add_mouse_event();
    }

    trigger() {
        super.trigger();
        console.log('do something(read sentence turn page)');

        const self = this;
        const turnPageFunc = function () {
            if (self.turnPageTimes.length == 0) return;
            if (self.audio.currentTime < self.turnPageTimes[0]) return;
            self.turnPageTimes.shift();

            window.soundManager.soundPlayer.pause();
            window.soundManager.switchMediaDisplay(false);
            //翻頁(翻頁時會暫停以及關閉播放器UI)
            window.pageControl.gotoPage(window.pageControl.nextPage);

            //將"重新開始播放"及"開啟播放器UI"寫入渲染完畢後的callBack
            self.itemControl.initCallBack = function () {
                window.soundManager.switchMediaDisplay(true);
                window.soundManager.seekEndHandler();
            };
        }

        const endFunc = function () {
            self.audio.removeEventListener("timeupdate", turnPageFunc)
        }

        self.audio.addEventListener("timeupdate", turnPageFunc);
        soundManager.setCallBackFunc(endFunc);
    }

    add_mouse_event() {
        this.target.mouseChildren = false;
        this.target.removeAllEventListeners();
        this.target.addEventListener("click", () => {
            this.trigger();
            let frame = this.isTrigger ? 1 : this.normalFrame;
            this.target.gotoAndStop(frame);
        });
    }
}